//import cn from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { SectionProps } from "@/components/common/interface/interfaces";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { Tooltip } from "antd";
import SIcon from "@/components/common/icon/sicon";
import { Capacitor } from "@capacitor/core";
import { appRouterPush, getPrefetch, isAndroidRouter } from "@/util/apputil";
import { useRouter } from "next/navigation";
import { tooltipColor } from "../list/defaultType";

export default function HeaderItem({ item, active, props }: { item: any; active?: boolean; props: SectionProps }) {
  const t = useTranslations("header");
  const title = t(item.title ?? "");
  const prefetch = getPrefetch();
  const router = useRouter();
  const isApp = Capacitor.isNativePlatform();
  return (
    <Tooltip color={tooltipColor} title={title} classNames={{ root: "mainTooltip " + isApp ? "hidden" : "md:hidden" }}>
      <div className="group transition m-0 p-0 inline-flex">
        <Link
          href={props.pathname + `/` + (item.name ?? "")}
          aria-label={`Header ${item.name}`}
          title={title}
          prefetch={prefetch}
          className={cn(
            active ? "isActive" : "",
            "screenAnimation group-link inline-block p-4 py-2 md:py-3 m-0 relative max-w-xs overflow-hidden bg-cover bg-no-repeat rounded-[0.5rem] transition-all group-active:animate-jump animate-once duration-300 group-hover:duration-1000 group-hover:animate-duration-1000 animate-ease-out",
          )}
          onClick={
            isAndroidRouter()
              ? (e) => {
                  e.preventDefault();
                  // router.push(props.pathname + `/` + (item.name ?? ""));
                  appRouterPush(router, props.pathname + `/` + (item.name ?? ""));
                  // window.location.href = props.pathname + `/` + (item.name ?? "");
                }
              : undefined
          }
        >
          <SIcon
            iconType="phosphor"
            iconName={item.icon}
            color={active ? "var(--ci-active-font-color)" : "var(--ci-font-color)"}
            className={cn(
              item.iconClassName,
              "screenAnimation group-icon block md:inline-block w-[2rem] h-[2rem] md:w-[2rem] md:h-[2rem] lg:w-[2.5rem] lg:h-[2.5rem] mx-1 my-0 md:my-0 md:mx-4 md:ml-0 transition-all duration-300",
            )}
          />
          <span className="screenAnimation group-name min-w-[3rem] hidden md:inline-block align-middle">{title}</span>
          <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-gradient-to-br from-amber-300 via-amber-600 to-amber-500 opacity-0 transition duration-1000 ease-out rounded-[0.5rem] group-hover:opacity-20 dark:group-hover:opacity-30 z-0"></div>
        </Link>
      </div>
    </Tooltip>
  );
}
